module.exports = __webpack_public_path__ + "static/media/afip.fbfe21fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/sobrePedraza/compra-segura/afip.png
// module id = 243
// module chunks = 0